const { h, createContext } = window.preact;
const { useContext, useState, useEffect } = window.preactHooks;
const html = window.htm.bind(h);

// Create the context
export const RollenfinderContext = createContext(null);

// Create a provider component
export function RollenfinderProvider({ children }) {
  const [state, setState] = useState({
    selectedManufacturers: [],
    selectedModel: null,
    specialRequirements: {
      // Filter categories
      besonderheit: [],
      motiv: [],
      aufdruck: null,
      durchschlag: null,
      sepa_lastschrift_aufdruck: null,
      // Specification fields
      rollenbreite: "",
      durchmesser_rolle: "",
      huelse_rollenkern: "",
      rollenlaenge: "",
      rollen_pro_karton: "",
    },
    fittingProducts: [],
    isSearching: false
  });

  const updateState = (newState) => {
    setState((prevState) => {
      // Create a clean copy using spread operator
      const updatedState = {
        ...prevState,
        ...newState,
        // Ensure nested objects are also copied
        specialRequirements: {
          ...prevState.specialRequirements,
          ...(newState.specialRequirements || {})
        }
      };
      
      return updatedState;
    });
  };

  return html`
    <${RollenfinderContext.Provider} value=${{ state, updateState }}>
      ${children}
    <//>
  `;
}

// Custom hook for using the Rollenfinder context
export function useRollenfinder() {
  const context = useContext(RollenfinderContext);
  if (!context) {
    throw new Error('useRollenfinder must be used within a RollenfinderProvider');
  }
  return context;
} 